import React from "react";

export class NoIconResults extends React.Component {
    constructor(props) {
        super(props);

        this.displayName = "NoIconResults";
        this.emptySearches = ["", null];
        this.weirdSearches = ["antidisestablishmentarianism"];
    }
    render() {
        let iconLink,
            message,
            note,
            ref,
            ref1,
            searchEverythingLink,
            suggestionLink;

        if (((ref = this.props.query), this.emptySearches.indexOf(ref) >= 0)) {
            message = gettext("Try searching for something above");
        } else {
            message =
                gettext("We didn’t find any icons for") +
                " “" +
                this.props.query +
                "”";
            if (this.props.creator) {
                message += gettext(" by this user");
            }
            if (this.props.collection) {
                message += gettext(" in this collection");
            }
            if (this.props.creator || this.props.collection) {
                searchEverythingLink = (
                    <p>
                        <a
                            href={"/search/?q=" + this.props.query}
                            className="text-link"
                        >
                            {gettext("Search all of Noun Project")}
                        </a>
                    </p>
                );
            }
            if (this.props.suggestion) {
                let suggestion = "/search/?q=" + this.props.suggestion;

                switch (this.props.scope) {
                    case "creator":
                        suggestion = `/search/?q=${this.props.query}&creator=${
                            this.props.creator.user_ptr_id
                        }`;
                        break;
                    case "collection":
                        suggestion = `/search/?q=${
                            this.props.query
                        }&collection=${this.props.collection.id}`;
                        break;
                }

                suggestionLink = (
                    <p>
                        <a href={suggestion} className="text-link">
                            {gettext("Did you mean “") +
                                this.props.suggestion +
                                "”?"}
                        </a>
                    </p>
                );
            }
            if (
                ((ref1 = this.props.query),
                this.weirdSearches.indexOf(ref1) >= 0)
            ) {
                note = <p>{gettext("Uh... that was a weird search.")}</p>;
            }
        }
        return (
            <section id="no-icon-results" className="no-results container">
                <img src={require("../../img/click.png")} alt="Compass" />
                <h2 className="section-heading">{message}</h2>
                {searchEverythingLink}
                {suggestionLink}
                {iconLink}
                {note}
            </section>
        );
    }
}
